import { render, staticRenderFns } from "./crudLeadsServices.vue?vue&type=template&id=77d947e5&scoped=true&"
import script from "./crudLeadsServices.vue?vue&type=script&lang=js&"
export * from "./crudLeadsServices.vue?vue&type=script&lang=js&"
import style0 from "./crudLeadsServices.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crudLeadsServices.vue?vue&type=style&index=1&lang=css&"
import style2 from "./crudLeadsServices.vue?vue&type=style&index=2&id=77d947e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d947e5",
  null
  
)

export default component.exports